var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_UsageReports-BlankView"},[_c('div',{staticClass:"_UsageReports-BlankView-Content"},[_c('CIcon',{attrs:{"material":"","name":"bar_chart"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }